import React from 'react';
import { Facebook, Instagram, Youtube, MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-neutral-900 text-white py-12 border-t border-neutral-800" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-26">
          <img src="https://cdn.magicpatterns.com/uploads/vQu9ZWVKGsSy7MjW77SDKE/logo.png" alt="HLD Taekwondo" className="h-16 sm:h-20" data-id="element-27" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-28">
          {/* Contact Info */}
          <div className="space-y-4" data-id="element-29">
            <h3 className="text-xl font-bold mb-6 text-white" data-id="element-30">Contact</h3>
            <div className="flex items-start space-x-3 text-neutral-300" data-id="element-31">
              <MapPin className="w-5 h-5 mt-1 text-red-600 shrink-0" data-id="element-32" />
              <p data-id="element-33">
                5144 Route 132,
                <br data-id="element-34" />
                Sainte-Catherine, QC, J5C 1L8
              </p>
            </div>
            <div className="flex items-center space-x-3 text-neutral-300" data-id="element-35">
              <Phone className="w-5 h-5 text-red-600 shrink-0" data-id="element-36" />
              <a href="tel:450-638-6584" className="hover:text-white transition-colors" data-id="element-37">
                450-638-6584
              </a>
            </div>
            <div className="flex items-center space-x-3 text-neutral-300" data-id="element-38">
              <Mail className="w-5 h-5 text-red-600 shrink-0" data-id="element-39" />
              <a href="mailto:hldtaekwondoca@gmail.com" className="hover:text-white transition-colors" data-id="element-40">
                hldtaekwondoca@gmail.com
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="space-y-4" data-id="element-41">
            <h3 className="text-xl font-bold mb-6 text-white" data-id="element-42">
              Heures d'ouverture
            </h3>
            <div className="space-y-2 text-neutral-300" data-id="element-43">
              <div className="flex items-start space-x-3" data-id="element-44">
                <Clock className="w-5 h-5 mt-1 text-red-600 shrink-0" data-id="element-45" />
                <div data-id="element-46">
                  <p data-id="element-47">
                    <span className="font-medium text-white" data-id="element-48">
                      Lundi – Vendredi :
                    </span>
                  </p>
                  <p data-id="element-49">8h00 – 12h00 / 16h45 – 20h30</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 pt-2" data-id="element-50">
                <div className="w-5 shrink-0" data-id="element-51" /> {/* Spacer alignment */}
                <div data-id="element-52">
                  <p data-id="element-53">
                    <span className="font-medium text-white" data-id="element-54">Samedi :</span>{' '}
                    9h00 – 12h00
                  </p>
                  <p data-id="element-55">
                    <span className="font-medium text-white" data-id="element-56">Dimanche :</span>{' '}
                    Fermé
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Social & Brand */}
          <div className="space-y-6" data-id="element-57">
            <h3 className="text-xl font-bold mb-6 text-white" data-id="element-58">Suivez-nous</h3>
            <div className="flex space-x-4" data-id="element-59">
              <a href="#" className="bg-neutral-800 p-3 rounded-full hover:bg-red-600 transition-colors duration-300 group" aria-label="Facebook" data-id="element-60">
                <Facebook className="w-6 h-6 text-white" data-id="element-61" />
              </a>
              <a href="#" className="bg-neutral-800 p-3 rounded-full hover:bg-red-600 transition-colors duration-300 group" aria-label="Instagram" data-id="element-62">
                <Instagram className="w-6 h-6 text-white" data-id="element-63" />
              </a>
              <a href="#" className="bg-neutral-800 p-3 rounded-full hover:bg-red-600 transition-colors duration-300 group" aria-label="YouTube" data-id="element-64">
                <Youtube className="w-6 h-6 text-white" data-id="element-65" />
              </a>
            </div>
            <p className="text-neutral-500 text-sm mt-8" data-id="element-66">
              © HLD Taekwondo — Sainte-Catherine
            </p>
          </div>
        </div>
      </div>
    </footer>;
}